export const PLAYER_FOCUS_KEY_INFO = 'PlayerInfo';
export const PLAYER_FOCUS_KEY_SUBTITLE = 'PlayerSubtitle';
export const PLAYER_FOCUS_KEY_SOUND = 'PlayerSound';
export const PLAYER_FOCUS_KEY_SKIP_FORWARD = 'PlayerSkipForward';
export const PLAYER_FOCUS_KEY_SKIP_BACKWARD = 'PlayerSkipBackward';
export const PLAYER_FOCUS_KEY_LIVE = 'PlayerLive';
export const PLAYER_FOCUS_KEY_RECORD = 'PlayerRecord';
export const PLAYER_FOCUS_KEY_REPLAY = 'PlayerReplay';
export const PLAYER_FOCUS_KEY_SCRUBBER = 'PlayerScrubber';
export const PLAYER_FOCUS_KEY_TOGGLE_PLAY = 'PlayerTogglePlay';
export const PLAYER_FOCUS_KEY_ROOT = 'PlayerRoot';

export const AUTO_HIDE_TIMEOUT = 3000;

// used to identify interactive elements in the player overlay
export const PLAYER_CONTROLS_INTERACTIVE_SELECTOR =
  'button, [role="slider"], [data-interactive-control]';
